var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"zero_padding_toolbar",attrs:{"flat":""}},[(_vm.icon)?_c('v-avatar',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1):_vm._e(),_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._t("buttons")],2)}
var staticRenderFns = []

export { render, staticRenderFns }